import TargetInput from './TargetInput';

export default TargetInput;
